import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="h-screen flex items-center justify-center text-slate-500 label-mono">
        Cargando…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role) && user.role !== "admin")
    return <Navigate to={user.role === "mecanico" ? "/workshop" : "/dashboard"} replace />;
  return children;
}
